import { inject, Injectable } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

import { map, Observable, take } from 'rxjs';

import { IrisModalService, IrisModalSize } from '@sondermind/iris/modal';
import { IComponentCanDeactivate } from '@sondermind/features/provider-facing/provider-profile';

import {
  PendingChangesModalComponent
} from '../components/pending-changes-modal/pending-changes-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ProfilePendingChangesGuardService {
  constructor(private irisModalService: IrisModalService) {}

  canDeactivate(component: IComponentCanDeactivate): boolean | Observable<boolean> {
    if (component?.canDeactivate && component?.canDeactivate()) return true;

    const modalRef = this.irisModalService.open<PendingChangesModalComponent, string, boolean>(
      PendingChangesModalComponent,
      {
        size: IrisModalSize.MD,
        title: 'Leave page without saving?'
      }
    );

    return modalRef.afterClosed$().pipe(
      take(1),
      map((closeWithoutSaving: boolean) => !!closeWithoutSaving)
    );
  }
}

export const PROFILE_PENDING_CHANGES_GUARD: CanDeactivateFn<IComponentCanDeactivate> = (
  component: IComponentCanDeactivate
): boolean | Observable<boolean> => {
  const guardService = inject(ProfilePendingChangesGuardService);
  return guardService.canDeactivate(component);
};
